import { fetchAuthSession, signOut } from "aws-amplify/auth";
import { useContext, useEffect } from "react";
import { UserTypeContext } from "../contexts/UserTypeContext";
import enumStrings, { RoutePaths } from "../enumStrings";
import { UserType } from "../graphql/types";

const useInitialAuth = (setIsLoggedIn: (val: any) => void) => {
  const {
    setters: { setUserType },
  } = useContext(UserTypeContext);
  return useEffect(() => {
    const checkAccessToken = async (): Promise<void> => {
      let accessTokenIsValid = false;
      let userType = null;
      try {
        const res = await fetchAuthSession();

        if (res?.tokens?.accessToken?.payload) {
          // @ts-ignore
          userType = res.tokens.accessToken.payload["cognito:groups"][0];

          if (
            userType === UserType.ChamberAdmin
            //  ||
            // userType === UserType.ChamberMemberAdmin
          ) {
            accessTokenIsValid = true;
          }
        }
      } catch (error) {
        if (error !== "No current user") {
          throw error;
        }
      }

      const urlPath = window.location.pathname;
      if (!accessTokenIsValid) {
        setIsLoggedIn(false);
        setUserType(null);
        await signOut();

        const loggedInWithTemporaryPassword = sessionStorage.getItem(
          enumStrings.sessionStorageKey.loggedInWithTemporaryPassword
        );

        if (loggedInWithTemporaryPassword) {
          if (urlPath !== RoutePaths.newPassword) {
            window.location.href = RoutePaths.newPassword;
            return;
          }
        }

        // user isn't logged in and isn't trying to access the cpa delete account page or isn't setting their permanent password... so force them to the login page
        if (urlPath !== RoutePaths.login && !loggedInWithTemporaryPassword) {
          window.location.href = RoutePaths.login;
        }
      } else {
        setUserType(userType);
        setIsLoggedIn(true);

        if (urlPath === RoutePaths.login) {
          window.location.href = RoutePaths.home;
          return;
        }
      }
    };
    checkAccessToken();
  }, [setIsLoggedIn, setUserType]);
};

export default useInitialAuth;
